<template>
  <div class="w-full">
    <h6 class="dashboard__red">Motivos de Negaciones</h6>
    <div class="dashboard__card_container dashboard__denny_stats">
      <div class="dashboard__max_table">
        <table class="dashboard__table w-full dashboard__normal_table">
          <thead>
          <tr>
            <th></th>
            <th>Aprobadores</th>
            <th class="dashboard__red">Denegadas</th>
          </tr>
          </thead>
          <tbody class="dashboard__table_darken">
            <tr v-for="item of approvers" :key="item.id" @click="selectApprover(item.id)" :class="['cursor_pointer', {'selected_row': selectedApprove === item.id}]">
              <td><span class="dashboard__profile_image" :style="{'background-image': `url(${item.photo})`}"></span></td>
              <td>{{ item.name }}</td>
              <td class="dashboard__red t_align_center">{{ item.denied }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- show stats per denny goes here -->
      <div class="w-full" v-if="selectedApprove">
        <table class="dashboard__table w-full dashboard__normal_table">
          <thead>
            <tr>
              <th>Descripción</th>
              <th>Cantidad</th>
            </tr>
          </thead>
          <tbody class="dashboard__table_darken t_align_center">
            <tr v-for="item of stats">
              <td>{{ item.name }}</td>
              <td>{{ item.quantity }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import DashboardService from '../../../services/DashboardService';
export default {
  data: () => ({
    selectedApprove: null,
    approvers: [],
    stats: [],
  }),
  mounted () {
    this.setLoader(true);
    this.initalizeAsync().then(async () => {
      await this.getApprovers();
      this.setLoader(false);
    });
  },
  methods: {
    async initalizeAsync() {
      Promise.resolve(resolve => {
        setTimeout(() => resolve(), 10);
      });
    },
    async selectApprover(id) {
      try {
        const params = {
          user_id: id,
          location_id: this.getLocation || undefined,
          start_date: this.getStartDate ? new Date(this.getStartDate) : undefined,
          end_date: this.getEndDate ? new Date(this.getEndDate) : undefined,
        }
        this.stats = await DashboardService.getDeniedSpecificStats(params);
        this.selectedApprove = id;
      } catch(err) {
        console.error(err);
        
      }

    },
    async getApprovers() {
      try {
        this.selectedApprove = null;
        const params = {
          location_id: this.getLocation || undefined,
          start_date: this.getStartDate ? new Date(this.getStartDate) : undefined,
          end_date: this.getEndDate ? new Date(this.getEndDate) : undefined,
        }
        this.approvers = await DashboardService.getDenialStats(params);
      }catch(err) {
        console.error(err);
        
      }
    },
  },
  watch: {
    'getLocation': {
      deep: true,
      handler() {
        this.selectedApprove = null;
        this.getApprovers();
      },
    },
    'getUser': {
      deep: true,
      handler() {
        this.selectedApprove = null;
        this.getApprovers();
      }
    },
    'getStartDate': {
      deep: true,
      handler() {
        this.selectedApprove = null;
        this.getApprovers();
      }
    }
  }
}
</script>